import React from 'react'

function ViewHandoverRegister({ handoverRegisterData = {} }) {
  return (
    <div className="row">
      <div className="col-lg-6 col-sm-12 mb-3">
        <label className="form-label">Customer Sales#</label>
        <input
          type="text"
          className="form-control"
          value={`${handoverRegisterData.SalesNumber || ''} (${handoverRegisterData.CustomerName || '-'})`}
          disabled
        />
      </div>
      <div className="col-lg-6 col-sm-12 mb-3">
        <label className="form-label">Payment Mode</label>
        <input
          type="text"
          className="form-control"
          value={handoverRegisterData.PaymentMode || ''}
          disabled
        />
      </div>
      <div className="col-lg-6 col-sm-12 mb-3">
        <label className="form-label">Customer Mobile</label>
        <input
          type="text"
          className="form-control"
          value={handoverRegisterData.MobileNumber || ''}
          disabled
        />
      </div>
      <div className="col-lg-6 col-sm-12 mb-3">
        <label className="form-label">Email</label>
        <input
          type="text"
          className="form-control"
          value={handoverRegisterData.EmailId || ''}
          disabled
        />
      </div>
      <div className="col-lg-6 col-sm-12 mb-3">
        <label className="form-label">Status</label>
        <input
          type="text"
          className="form-control"
          value={handoverRegisterData.Status || ''}
          disabled
        />
      </div>
      <div className="col-lg-6 col-sm-12 mb-3">
        <label className="form-label">Remark</label>
        <textarea
          className="form-control"
          rows="2"
          value={handoverRegisterData.Remark || ''}
          disabled
        ></textarea>
      </div>
    </div>
  )
}

export default ViewHandoverRegister
